import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { ButtonBase, Stack } from "@mui/material";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import clipboardIllustration from "@src/appV2/lib/assets/images/clipboard-illustration.png";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";
import { Button } from "@src/appV2/redesign/components/Button";
import { CbhIcon, Divider, Image, Text } from "@src/appV2/redesign/system/ui-components";

import { ActionBannerIconWrapper } from "../../ActionBannerIconWrapper";
import { DocumentDetailsBannerWithAction } from "../../BannerWithAction";
import { DocumentDetailsStatusCard } from "../../StatusCard";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";

export const TB_TEST_URL =
  "https://apply.checkr.com/apply/bluebirdhealthcarestaffing/ef76fe17c06240ced5dd6c2a55e624a9";

export function TbTestWithAppointmentStatusCard() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { requirementId } = workerRequirement;
  const { expiry, status } = workerRequirement;

  const handleCtaClick = async () => {
    logEvent(APP_V2_USER_EVENTS.CLICKED_CTA_ON_IMPROVED_TB_TEST_BUTTON, {
      requirement_id: requirementId,
      status,
    });
    await openInBrowser({ url: TB_TEST_URL });
  };

  return status === WorkerRequirementStatus.EXPIRING ||
    status === WorkerRequirementStatus.MISSING ? (
    <DocumentDetailsBannerWithAction
      variant={status}
      expiryDate={expiry ? new Date(expiry) : undefined}
      header="Don't have a TB test?"
      subHeader="Schedule a free test or upload an existing test result"
      button={
        <Button
          invert
          variant="contained"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          onClick={handleCtaClick}
        >
          Schedule a free test!
        </Button>
      }
      illustration={<Image width={104} src={clipboardIllustration} alt="Clipboard Illustration" />}
    />
  ) : (
    <DocumentDetailsStatusCard
      footer={
        status === WorkerRequirementStatus.REJECTED ||
        status === WorkerRequirementStatus.EXPIRED ? (
          <Stack direction="column" spacing={5}>
            <Divider />
            <ButtonBase sx={{ textAlign: "left" }} onClick={handleCtaClick}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Stack direction="row" spacing={3} alignItems="center">
                  <ActionBannerIconWrapper
                    imageSource={clipboardIllustration}
                    imageAlt="Clipboard Illustration"
                  />
                  <Text semibold variant="body1">
                    Schedule a new, free test now!
                  </Text>
                </Stack>
                <CbhIcon size="small" type="chevron-right" />
              </Stack>
            </ButtonBase>
          </Stack>
        ) : null
      }
    />
  );
}
